import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatPaginator, MatSort, MatTableDataSource} from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { first } from "rxjs/operators";
import { EventManagementService } from "src/app/services/event-management.service";
import { EventPeoDialogComponent } from './event-peo-dialog/event-peo-dialog.component';
import { UserService } from "src/app/services/user.service";
import { TokenStorage } from "src/app/util/token.storage";
import { WebConstants } from "src/app/util/web.constants";

@Component({
  selector: 'app-event-management',
  templateUrl: './event-management.component.html',
  styleUrls: ['./event-management.component.scss']
})
export class EventManagementComponent implements OnInit {

  public displayedColumns: string[] = [
    "eventName",
    "phoneNumber",
    "startDate",
    "endDate",
    "noOfExpectedGuest",
    "noOfRegisteredVehicles",
    "noOfVolunteersRequired",
    "actions",
  ];

  public dataSource = new MatTableDataSource();
  public title: string = WebConstants.MENU_NAMES.EVENT_MANAGEMENT;
  public upcomingEventData: any[] = [];
  public allPeoData: any;
  public selectedPeoId: any = 0;
  public selectedEvent: any;
  public selectedEventId: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public eventManagementService: EventManagementService,
    public userService: UserService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log("Event Management");
    this.getAllEnforcementVehicle();
    this.getAllPeoUsers();
  }

  getAllEnforcementVehicle(): void {
    this.eventManagementService.getAllUpcoming().pipe(first()).subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.upcomingEventData = response.data;
          this.dataSource = new MatTableDataSource(this.upcomingEventData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } 
        else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  getAllPeoUsers(){
    this.userService.getAll().pipe(first()).subscribe((response) => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.allPeoData = response.data.filter((x: any) => x.roleId == 13 && x.status == 1 );
      } 
      else {
        this.toastrService.error(response.value, "Failed To Load Data!");
      }
    });
  }

  addPeoDialog(data: any){
    this.selectedEvent = data;
    this.selectedEventId = data.eventId;
  }
  
  linkPeoWithEvent(): void {
    if(this.selectedPeoId){
      console.log(this.selectedPeoId);
      
      let linkPeoList = [];
      let objEventPeo = {
        eventId: this.selectedEventId,
        peoId: this.selectedPeoId,
        eventExpireDate: Date.parse(this.selectedEvent.endDate)
      }

      linkPeoList.push(objEventPeo);

      this.eventManagementService.assignEventPeo(linkPeoList).pipe(first()).subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "PEO Assigned Successfully!");
        }
        else {
          this.toastrService.error(response.value, "Failed To Assign PEO!");
        }
      });
    }
    else{
      this.toastrService.error("Please Select PEO", "Failed To Add PEO!");
    }
  }

  eventPeoDetail(data: any): void {
    const dialogRef = this.dialog.open(EventPeoDialogComponent, {
      //height: "100vh",
      maxHeight: "150vh",
      data: data
    });
  }
}
